
@if (visible) {
  <button class="upgrade-fab" mat-fab color="primary" (click)="upgrade()">
    <mat-icon>upgrade</mat-icon>
    <span class="extended-fab-button__text">Upgrade!</span>
  </button>
}